import API from '@/api/index';

const geofence = {
  state: {
    geofences: [],
    selectedGeofence: null,
    isAddGeofence: false,
    isEditGeofence: false,
    addGeofenceRadius: 200,
    addGeofenceLatLng: {}
  },

  mutations: {
    SET_GEOFENCES: (state, list) => {
      state.geofences = list;
    },
    SET_SELECTED_GEOFENCE: (state, fence) => {
      state.selectedGeofence = fence;
    },
    SET_ADD_GEOFENCE_STATE: (state, isAdd) => {
      state.isAddGeofence = isAdd;
    },
    ADD_GEOFENCE: (state, fence) => {
      state.geofences.push(fence);
    },
    SET_ADD_GEOFENCE_RADIUS: (state, radius) => {
      state.addGeofenceRadius = radius;
    },
    SET_ADD_GEOFENCE_LATLNG: (state, latlng) => {
      state.addGeofenceLatLng = latlng;
    },
    SET_EDIT_GEOFENCE_STATE: (state, isEdit) => {
      state.isEditGeofence = isEdit;
    },
    DELETE_GEOFENCE: (state, fence) => {
      state.geofences = state.geofences.filter(a => a.id !== fence.id);
    },
  },

  actions: {
    getGeofences ({ commit }) {
      return new Promise((resolve, reject) => {
        API.geofence.getGeofences().then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            commit('SET_GEOFENCES', result.data);
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    createGeofence ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.geofence.createGeofence(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    updateGeofence ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.geofence.updateGeofence(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    deleteGeofence ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.geofence.deleteGeofence(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    googleGeocoding ({ commit }, address) {
      return new Promise((resolve, reject) => {
        API.geofence.googleGeocoding(address).then(response => {
          let result = response.data.data.results;
          if (result.length > 0) {
            resolve(result[0].geometry.location);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
  }
};

export default geofence;


// WEBPACK FOOTER //
// ./src/store/modules/geofence.js